import { render, staticRenderFns } from "./PointSettlement.vue?vue&type=template&id=03eb68e8&scoped=true"
import script from "./PointSettlement.vue?vue&type=script&lang=js"
export * from "./PointSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb68e8",
  null
  
)

export default component.exports